import type { CmsContentId } from '@zep/next';

export const CmsEntries = {
  BANNERS: {
    ko: '3ee8007f-fff3-48a5-b09e-925778691b8b',
    en: '8c50e659-fcfc-402b-93e0-0b517918215c',
    ja: '5a079d27-f77b-4a26-ab67-815f05e582fc',
  },
  EXPLORE: {
    ko: '2572f3b3-26d7-4a20-a849-37ffb16c8fe1',
    en: '386fa5b7-6d17-41e9-a8a8-b39699df4d61',
    ja: 'e20aa8c0-6591-443e-89f5-03ee59bb3a83',
  },
} as const satisfies Record<string, CmsContentId>;
